import { getPageSource, track } from '@mc/track-event'
import { INSTRUCTOR_QUOTE_LOCATION } from './constants'

export const trackInstructorQuoteViewed = (quote: string) =>
  track('Page Section Viewed', {
    location: INSTRUCTOR_QUOTE_LOCATION,
    page_source: getPageSource(),
    quote,
  })
